'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaMicrophone = function FaMicrophone(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.7 15.7v2.9q0 4.9-3.3 8.6t-8.1 4.1v3h5.7q0.6 0 1 0.4t0.4 1-0.4 1-1 0.4h-14.3q-0.6 0-1-0.4t-0.4-1 0.4-1 1-0.4h5.7v-3q-4.8-0.5-8.1-4.1t-3.3-8.6v-2.9q0-0.6 0.4-1t1-0.4 1 0.4 0.5 1v2.9q0 4.1 2.9 7t7.1 3 7-3 3-7v-2.9q0-0.6 0.4-1t1-0.4 1 0.4 0.4 1z m-5.7-8.6v11.5q0 2.9-2.1 5t-5 2.1-5.1-2.1-2.1-5v-11.5q0-2.9 2.1-5t5.1-2.1 5 2.1 2.1 5z' })
        )
    );
};

exports.default = FaMicrophone;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/microphone.js
// module id = 734
// module chunks = 79611799117203